import React from 'react';
import SvgProps from './SvgProps';

export const LockIcon = (props: SvgProps): JSX.Element => {
    const { width = 34, height = 26 } = props;
    return (
        <svg id="lock_black_24dp" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20">
            <g id="Group_12163" data-name="Group 12163">
                <path id="Path_26842" data-name="Path 26842" d="M0,0H20V20H0Z" fill="none" />
                <path id="Path_26843" data-name="Path 26843" d="M0,0H20V20H0Z" fill="none" opacity="0.87" />
            </g>
            <path
                id="Path_26844"
                data-name="Path 26844"
                d="M15.667,6.833h-.833V5.167a4.167,4.167,0,0,0-8.333,0V6.833H5.667A1.672,1.672,0,0,0,4,8.5v8.333A1.672,1.672,0,0,0,5.667,18.5h10a1.672,1.672,0,0,0,1.667-1.667V8.5A1.672,1.672,0,0,0,15.667,6.833Zm-7.5-1.667a2.5,2.5,0,0,1,5,0V6.833h-5Zm7.5,11.667h-10V8.5h10Zm-5-2.5A1.667,1.667,0,1,0,9,12.667,1.672,1.672,0,0,0,10.667,14.333Z"
                transform="translate(-0.667 -0.167)"
                fill="#f6e05e"
                width="100%"
                height="100%"
            />
        </svg>
    );
};
